export function generateImageFromSeed(seed: string, mesh: boolean): string {
    if (mesh) {
        return "glide:mesh," + seed;
    } else {
        return "glide:triangles," + seed;
    }
}
